module.exports = __webpack_public_path__ + "img/uk.8fb04412.svg";